exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.flexbox-checkbox{list-style:none;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}[dir] .flexbox-checkbox{padding-top:15px;margin:0}[dir=ltr] .flexbox-checkbox,[dir=rtl] .flexbox-checkbox{padding-left:15px;padding-right:15px}@media (min-width:992px){[dir=ltr] .flexbox-checkbox,[dir=rtl] .flexbox-checkbox{padding-left:30px;padding-right:30px}}.flexitem-checkbox{-ms-flex-item-align:start;align-self:flex-start}[dir=ltr] .optionInformation{float:left;padding-left:15px}[dir=rtl] .optionInformation{float:right;padding-right:15px}input[type=checkbox]{line-height:normal}[dir] input[type=checkbox]{margin:4px 0 0}.checkBox{font-size:.62em;width:30px;height:30px}[dir] .checkBox{border:1px solid #3f3d3d}label{display:inline-block;max-width:100%;font-weight:700}[dir] label{margin-bottom:5px}.checkBoxSolid{height:100%}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/checkbox/checkbox.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/checkbox/checkbox.component.scss
// module chunks = 0